import { render, staticRenderFns } from "./KeyResults.vue?vue&type=template&id=4e4b4e12&"
import script from "./KeyResults.vue?vue&type=script&lang=js&"
export * from "./KeyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports